
(function($) {

    $(document).ready(function () {

        /* -- Pricing Strategy Table -- */
        var $strategyTable = $("table.strategy-table");

        $strategyTable.find('.strategy-cell-section').on("click", function (e) {
            var clickedElement = $(this);
            var toggleClass = clickedElement.find("td:first-child i").hasClass("fa-plus") ? "fa fa-minus" : "fa fa-plus";

            $(this).nextUntil('tr.strategy-cell-section').slideToggle('fast', function() {
                clickedElement.find("td:first-child i").attr("class", toggleClass);
            });
        });

    });

})(jQuery);
